module.exports = __webpack_public_path__ + "static/media/NotoSans-Light.da834ccc.ttf";